import log from "loglevel";
import prefix from "loglevel-plugin-prefix"

export function formatObj(message: object | undefined): string {
    if (message === undefined) {
        return 'undefined'
    }
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    return Object.entries(message).map(([key, value]) => `${key}="${value}"`).join(' ')
}

export function getLogger(name: string, level?: log.LogLevelDesc): log.Logger {
    const logger = log.getLogger(name)
    if (level) logger.setLevel(level)
    prefix.reg(log)
    prefix.apply(logger, {
        template: '[%t] %n %l:'
    })
    return logger
}
